/**
 * The wordmark: the mark, then the name in two tones.
 *
 * It lives in one file because it is the only place the brand appears with no
 * other context around it, and because it was previously copied into the shell
 * and the sign-in page as identical SVG — two copies of the one thing that must
 * never differ between the app and the site.
 *
 * Per docs/design-system.md §12: lowercase always, the first word in `--text`
 * and the second in `--accent-ink`; the mark is an `--accent-ink` ground with
 * its glyph in `--on-accent-ink`. The ground is deliberately the *ink* accent
 * and not `--accent`: the fill gold is 1.55:1 on paper, so a mark this small
 * painted in it is not legible, and `--accent` is reserved for what has been
 * sealed. The glyph is the label ink, not `--action`: on the dimmed sheet the
 * mark is a light blue, and near-white on it is 2.88:1.
 *
 * The glyph takes `fill`/`stroke` from CSS rather than a presentation
 * attribute, because a presentation attribute cannot be reached by a `color`
 * rule; that is how the mark was once a white square.
 */
export function Wordmark() {
  return (
    <>
      <div className="logo-mark" aria-hidden>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M4 4h8v2H4V4zm0 3h5v2H4V7zm0 3h6v2H4v-2z" fill="currentColor" />
        </svg>
      </div>
      <span>
        docs<em>done</em>
      </span>
    </>
  )
}
